import React from "react";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import plus from "icons/plus-purple.svg";
import Table from "components/Table";
import WorkspacesUsersTableItem from "layout/systemAdmin/workspaces/WorkspacesUsersTableItem";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { fetchUsers } from "slices/systemAdmin/actions/users";

const WorkspacesUsersTable = ({ users, workspaceName, workspaceId }) => {
  const dispatch = useDispatch();

  const header = () => (
    <div className="system_admin__container__item__table__header">
      <span>Members</span>
      <span>Multiple Workspaces</span>
      <span>First Name</span>
      <span>Last Name</span>
      <span>&nbsp;</span>
      <span>Licensed User</span>
      <span>Edit Dictionaries</span>
      <span>Edit Readability Settings</span>
      <span>Edit Acronym Settings</span>
      <span>Edit Discovery Settings</span>
      <span>Edit Excel Outputs</span>
      <span>Administer Users</span>
      <span>&nbsp;</span>
    </div>
  );

  const handleAddMemberButton = async () => {
    await dispatch(fetchUsers());
    const currentLicensedUsers = users.filter(
      (user) => user.licensed === true
    ).length;
    dispatch(
      showModal(modalTypes.ADD_USER_TO_WORKSPACE, {
        workspaceId,
        currentLicensedUsers,
      })
    );
  };

  const addMemberButton = () => (
    <Button
      onClick={handleAddMemberButton}
      variant={buttonVariants.borderless}
      content={
        <div>
          <img src={plus} alt="plus" />
          <span>Add Member</span>
        </div>
      }
      dataTestId="add-member-button"
    />
  );

  return (
    <Table
      rows={[
        <>
          {users.map((u) => (
            <WorkspacesUsersTableItem
              licensed={u.licensed}
              dictionary={u.dictAdmin}
              readabilitySettings={u.readabilitySettingsAdmin}
              acronymSettings={u.acronymSettingsAdmin}
              discoverySettings={u.discoverySettingsAdmin}
              excelOutputs={u.excelOutputsAdmin}
              lastName={u.lastName}
              member={u.username}
              firstName={u.firstName}
              multipleWorkspaces={u.workspaces.length > 1}
              userAdmin={u.userAdmin}
              workspaceName={workspaceName}
              workspaceId={workspaceId}
            />
          ))}
        </>,
        <div className="system_admin__container__item__table__add__member">
          {addMemberButton()}
        </div>,
      ]}
      header={header()}
    />
  );
};

export default WorkspacesUsersTable;

WorkspacesUsersTable.propTypes = {
  users: PropTypes.arrayOf(
    PropTypes.shape({
      username: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      licensed: PropTypes.bool.isRequired,
      dictAdmin: PropTypes.bool.isRequired,
      readabilitySettingsAdmin: PropTypes.bool.isRequired,
      acronymSettingsAdmin: PropTypes.bool.isRequired,
      discoverySettingsAdmin: PropTypes.bool.isRequired,
      excelOutputsAdmin: PropTypes.bool.isRequired,
      userAdmin: PropTypes.bool.isRequired,
    }).isRequired
  ).isRequired,
  workspaceName: PropTypes.string.isRequired,
  workspaceId: PropTypes.number.isRequired,
};
